import React, { useCallback, useContext } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import {
  makeGetUpgradeCtaData,
  makeGetCardTitle,
  makeGetInterstitialToApp,
  makeGetApplyNowOnClick,
  makeGetApplyNowUrl,
  makeGetApplyNowDtm,
  makeGetApplyNowId
} from '../redux';
import { isG171Experiment } from 'src/universal/components/Experiments/G171/redux';

import removeTags from 'service_modules/utils/text-remove-tags';
import { triggerCmPznClickEvent } from 'src/universal/utils/orchestraCmPznClickEvent';
import {
  sendDTMClickEvent,
  mapUrlWithDtmLinkQuery
} from 'service_modules/models/dtm-tagging';

import { Type, Color, Button, Icon } from '@americanexpress/aqx-components';
import { InterstitialModalContext } from '../../../';

import styles from '../__styles__/ctas.scss?modules';

const ApplyNowCta = ({
  upgradeCtaData,
  cardTitle,
  shortName,
  interstitialToApp,
  applyNowOnClick,
  applyNowUrl,
  applyNowDtm,
  applyNowId,
  isBottomRow,
  isG171
}) => {
  const { needUpgradeCta, cmPznEventInfo } = upgradeCtaData;
  const { needClickEvent, offerEep, iaCode } = cmPznEventInfo;

  const applyText = 'Apply Now';
  const accessibleApplyText = removeTags(`${applyText} for ${cardTitle}`);
  const openInterstitialModal = useContext(InterstitialModalContext);

  const url = interstitialToApp
    ? undefined
    : mapUrlWithDtmLinkQuery(applyNowUrl, applyNowDtm);

  const onClick = useCallback(
    e => {
      if (!interstitialToApp) {
        applyNowOnClick(e);
      } else {
        openInterstitialModal(interstitialToApp);
        if (needClickEvent) {
          triggerCmPznClickEvent({ pageId: null, offerEep, iaCode });
        }
      }
      sendDTMClickEvent({
        eventAction: 'Click',
        eventAsset: `SB-Apply-VAC_${shortName}`,
        eventType: 'pageInteraction'
      });
    },
    [
      interstitialToApp,
      applyNowOnClick,
      openInterstitialModal,
      needClickEvent,
      offerEep,
      iaCode,
      shortName
    ]
  );

  return (
    <Button
      Component="button"
      $type={needUpgradeCta ? Type.Secondary : Type.Primary}
      title={accessibleApplyText}
      aria-label={accessibleApplyText}
      onClick={onClick}
      href={url}
      id={applyNowId}
      className={clsx(styles.applyNowCta, { [styles.bottomRow]: isBottomRow })}
    >
      {!isG171 && (
        <Icon
          directory="dls"
          imageName="dls-icon-lock"
          theme={{ color: needUpgradeCta ? Color.BrightBlue : Color.White }}
          className={styles.icon}
        />
      )}
      {applyText}
    </Button>
  );
};

const mapStateToProps = () => {
  const getUpgradeCtaData = makeGetUpgradeCtaData();
  const getCardTitle = makeGetCardTitle();
  const getApplyNowClick = makeGetApplyNowOnClick();
  const getApplyNowUrl = makeGetApplyNowUrl();
  const getApplyNowDtm = makeGetApplyNowDtm();
  const getApplyNowId = makeGetApplyNowId();
  const getInterstitialToApp = makeGetInterstitialToApp();

  return (state, { shortName }) => ({
    upgradeCtaData: getUpgradeCtaData(state, shortName),
    cardTitle: getCardTitle(state, shortName),
    interstitialToApp: getInterstitialToApp(state, shortName),
    applyNowOnClick: getApplyNowClick(state, shortName),
    applyNowUrl: getApplyNowUrl(state, shortName),
    applyNowDtm: getApplyNowDtm(state, shortName),
    applyNowId: getApplyNowId(state, shortName),
    isG171: isG171Experiment(state)
  });
};

export default connect(mapStateToProps)(ApplyNowCta);
